module.exports = __webpack_public_path__ + "img/revision_moto_resize.099d0a4b.png";